
import { Cliente } from "./Cliente";
import { CuponPagoTarjeta } from "./CuponPagoTarjeta";
import { PagoElectronicoDto } from "./PagoElectronicoDto";

export class EmitirFactura
{
  facturaId: string;
  cupones: CuponPagoTarjeta [];
  observaciones: string;
  cliente: Cliente;

  _payment: PagoElectronicoDto[]; // uso local
}
